<template>
  <v-container class="containerMinHeight py-5">
    <div>
      <GlobalSubNav :title="title" :additionalChildren="additionalChildren" />
    </div>
    <v-row class="dataContainer" no-gutters>
      <v-row class="containerMinHeightinner pa-0 mx-0 mb-0 mt-7">
        <LeftNavigationPan v-if="sidebarAvailable && canView && showSidebar" />
        <v-col
          :cols="!showSidebar ? 12 : isLeftDrawerPanOpen ? 11 : 12"
          :md="!showSidebar ? 12 : isLeftDrawerPanOpen ? '' : 9"
          v-if="showSubContainer"
          class="py-5"
        >
          <v-col class="containerMinHeightinner pa-0 mx-0 mb-0 mt-1">
            <v-row class="rightDashboardContainer mx-auto my-0">
              <v-col class="pa-0">
                <router-view
                  :title="title"
                  :key="$route.path"
                  :isLeftDrawerPanOpen="isLeftDrawerPanOpen"
                >
                </router-view>
              </v-col>
            </v-row>
          </v-col>
        </v-col>
        <v-col v-else class="pa-0">
          <router-view
            :title="title"
            :key="$route.path"
            :isLeftDrawerPanOpen="isLeftDrawerPanOpen"
          >
          </router-view>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>
<script>
import EventBus from '@/EventBus.js';
import GlobalSubNav from '@/components/GlobalComponent/GlobalSubNav.vue';
import LeftNavigationPan from '@/components/Organisations/LeftNavigationPan.vue';
import { mapState } from 'vuex';
export default {
  props: {
    title: String,
    titleWithOrg: String,
    showSidebar: { type: Boolean, default: true, required: false },
    additionalChildren: { type: Array },
    showSubContainer: { type: Boolean, default: true }
  },
  components: {
    LeftNavigationPan,
    GlobalSubNav
  },
  data() {
    return {
      isLeftDrawerPanOpen: true,
      sidebarAvailable: true
    };
  },
  watch: {
    $route: {
      handler() {
        this.sidebarAvailable =
          this.$route.path === '/configuration/inprogress' ? false : true;
      },
      immediate: true
    }
  },
  computed: {
    ...mapState(['orgData']),
    /**
     * To check permission to view sidebar
     * only system admin & user with var status VAR_WHO_CAN_ADD_VARS/VAR_WHO_CANNOT_ADD_VARS, can view sidebar
     */
    canView() {
      const varStatus = this.orgData?.varStatus;
      return (
        this.$can('view', 'child_orgs') &&
        (this.$can('manage', 'system') ||
          varStatus === this.$enums.varStatus.canAddVars ||
          varStatus === this.$enums.varStatus.cannotAddVars)
      );
    }
  },
  mounted() {
    this.initData();
    this.initEvents();
  },
  methods: {
    initData() {
      const leftDrawerOpen = localStorage.getItem('leftDrawerOpen');
      if (leftDrawerOpen !== null && this.canView) {
        this.isLeftDrawerPanOpen = JSON.parse(leftDrawerOpen);
      }
    },
    initEvents() {
      EventBus.$on('drawerCollapsed', isLeftDrawerPanOpen => {
        this.isLeftDrawerPanOpen = !isLeftDrawerPanOpen;
      });
    }
  },
  beforeDestroy() {
    EventBus.$off('drawerCollapsed');
  }
};
</script>
